import type { IconData } from '@stacksjs/iconify-core'

export const contentFilesPhoneBook: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3.81 1.52h24.38v1.53H5.34v1.52h22.85V6.1H3.81v1.52h1.53v22.86H3.81V32h25.91v-1.52H6.86V7.62h22.86v22.86h1.52V6.1h-1.52V1.52h1.52V0H3.81z\"/><path fill=\"currentColor\" d=\"M25.15 12.19H9.91v1.53H8.38v3.04h4.58v-1.52h9.14v1.52h4.57v-3.04h-1.52zm-1.53 7.62H22.1v-1.52h-1.53v-1.53h-1.52v1.53H16v-1.53h-1.52v1.53h-1.52v1.52h-1.53v1.52H9.91v4.58h1.52v1.52h12.19v-1.52h1.53v-4.58h-1.53Zm-3.05 4.57h-1.52v1.53H16v-1.53h-1.52v-3.05H16v-1.52h3.05v1.52h1.52Z\"/><path fill=\"currentColor\" d=\"M16 21.33h3.05v3.05H16ZM2.29 28.95h1.52v1.53H2.29Zm0-27.43h1.52v1.53H2.29Zm0 4.58h1.52V4.57H2.29V3.05H.76v25.9h1.53z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default contentFilesPhoneBook
